function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.995 1.326l-1.827 3.049a9.454 9.454 0 00-10.026 2.4c-3.657 3.835-3.552 9.945.235 13.647a9.452 9.452 0 0013.48-.238c2.199-2.304 3.038-5.43 2.535-8.362l3.276-1.305c.953 4.194-.143 8.778-3.317 12.105a12.889 12.889 0 01-18.382.325c-5.164-5.05-5.308-13.38-.32-18.61a12.891 12.891 0 0114.346-3.011z",
  id: "spinner_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fillOpacity: 0.8,
  fill: "#000",
  fillRule: "nonzero",
  opacity: 0.8,
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  fillRule: "nonzero",
  opacity: 0.8,
  xlinkHref: "#spinner_svg__a",
  transform: "translate(7.333 6.667)"
}));

function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgSpinner;